<div class="deal-type-header">
  <span class="deal-type-header__title">Create New Deal</span>
  <span class="deal-type-header__subtitle">Select deal status</span>
  <button mat-icon-button mat-dialog-close class="deal-type-header__close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="deal-type-cards">
    <button
      class="deal-type-card"
      [class.deal-type-card--selected]="selected() === 'current'"
      (click)="selectCurrentDeal()">
      <svg
        class="deal-type-card__icon deal-type-card__icon--chart"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg">
        <rect rx="6" ry="6" width="48" height="48" fill="#e8e8e8" />
        <rect x="8" y="18" width="8" height="22" rx="2" fill="#4caf50" />
        <rect x="20" y="24" width="8" height="16" rx="2" fill="#7b1f3e" />
        <rect x="32" y="12" width="8" height="28" rx="2" fill="#3366cc" />
      </svg>
      <span class="deal-type-card__title">Current Deal</span>
      <span class="deal-type-card__description">
        Deal in progress - upload term sheet or enter manually
      </span>
    </button>

    <button
      class="deal-type-card"
      [class.deal-type-card--selected]="selected() === 'closed'"
      (click)="selectClosedDeal()">
      <svg
        class="deal-type-card__icon deal-type-card__icon--check"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg">
        <polyline
          points="12,25 20,33 36,15"
          fill="none"
          stroke="#3d7b8a"
          stroke-width="5"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="deal-type-card__title">Closed Deal</span>
      <span class="deal-type-card__description">
        Completed transaction - upload credit agreement or enter manually
      </span>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
